const appConfig = {
  appName: "Gorai Oven Delight's",
  orderChecker: {
    autoRefresh: {
      enabled: true,
      interval: 30, // seconds
    },
  },
};

export default appConfig;
